import * as Yup from "yup";
import { useState } from "react";

import ModalCustom from "../../../../../Components/Modal/ModalCustom";
import { Form, Text } from "../../../../../Components/Form";
import { useApi } from "../../../../../Hooks/Api";
import { useToast } from "../../../../../Hooks/Toast";
import { dateToJalali } from "../../../../../Utils/Helpers";

const validationSchema = Yup.object({
  zip_code: Yup.string()
    .required("کد پستی الزامی است")
    .min(10, "کد پستی باید 10 رقم باشد")
    .max(10, "کد پستی باید 10 رقم باشد"),
});

const GymModal = ({
  context,
  setZModalIsOpen,
  zModalIsOpen,
  addGymToUser,
  team = false,
  setEditTeam,
  setTeamModalObject,
}) => {
  const { get } = useApi();
  const { error } = useToast();
  const [searchLoading, setSearchLoading] = useState(false);

  const searchGym = async (values) => {
    setSearchLoading(true);
    await get(
      `/gym/find-by-zip-code/${values?.zip_code}`,
      (res) => {
        const { data } = res;
        if (Object.entries(data)?.length === 0) {
          setSearchLoading(false);
          return error("زورخانه ای با این کد پستی وجود ندارد.");
        }
        context.gym = data;
        setSearchLoading(false);
      },
      (err) => {
        error("دریافت اطلاعات زورخانه ناموفق بود");
        setSearchLoading(false);
      }
    );
  };

  return (
    <ModalCustom modalIsOpen={zModalIsOpen}>
      <Form
        initialValues={{
          zip_code: "",
        }}
        validationSchema={validationSchema}
        defaultActions={false}
        onSubmit={searchGym}
      >
        <div className='row'>
          <div className='col-12'>
            <div className='d-flex flex-row justify-content-start align-items-center border-bottom border-white'>
              <h1 className='text-white f-14 font-weight-bold'>افزودن تیم</h1>
            </div>
          </div>
          <div className='col-12 col-md-10 mt-1'>
            <Text
              title='کد پستی زورخانه'
              name='zip_code'
              labelClass='text-white my-2'
            />
          </div>
          <div className='col-12 col-md-2 mt-4'>
            {searchLoading ? (
              <button className='btn bg-info text-white f-13 mx-2 mt-3'>
                <div
                  className='spinner-border text-white spinner-border-sm mb-1'
                  role='status'
                >
                  <span className='sr-only'></span>
                </div>
              </button>
            ) : (
              <button
                type='submit'
                className='btn bg-info text-white f-13 mx-2 mt-3'
              >
                جستجو
              </button>
            )}
          </div>
          {context?.gym?.name !== undefined && (
            <>
              <div className='col-12 col-md-4 my-3'>
                <div className='d-flex flex-row align-items-center'>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    نام زورخانه :
                  </span>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    {context?.gym?.name}
                  </span>
                </div>
              </div>
              <div className='col-12 col-md-4 my-3'>
                <div className='d-flex flex-row align-items-center'>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    استان :{" "}
                  </span>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    {context?.gym?.province?.name}
                  </span>
                </div>
              </div>
              <div className='col-12 col-md-4 my-3'>
                <div className='d-flex flex-row align-items-center'>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    شهر :{" "}
                  </span>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    {context?.gym?.city?.name}
                  </span>
                </div>
              </div>
              <div className='col-12 col-md-4 my-3'>
                <div className='d-flex flex-row align-items-center'>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    تلفن زورخانه :{" "}
                  </span>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    {context?.gym?.phone}
                  </span>
                </div>
              </div>
              <div className='col-12 col-md-4 my-3'>
                <div className='d-flex flex-row align-items-center'>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    تاریخ تاسیس :{" "}
                  </span>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    {dateToJalali(context?.gym?.foundation_date)}
                  </span>
                </div>
              </div>
              <div className='col-12 col-md-4 my-3'>
                <div className='d-flex flex-row align-items-center'>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    مدیر زورخانه :{" "}
                  </span>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    {context?.gym?.first_name} {context?.gym?.last_name}
                  </span>
                </div>
              </div>
              <div className='col-12 my-3'>
                <div className='d-flex flex-row align-items-center'>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    آدرس :{" "}
                  </span>
                  <span className='text-white font-weight-bold f-13 mx-2'>
                    {context?.gym?.address}
                  </span>
                </div>
              </div>
            </>
          )}
        </div>
      </Form>
      <div className='row'>
        <div className='col-12'>
          <span
            className='btn bg-danger text-white f-13 c-pointer'
            onClick={() => {
              context.gym = {};
              if (team) {
                setEditTeam(false);
                setTeamModalObject({});
              }
              setZModalIsOpen(false);
            }}
          >
            انصراف
          </span>
          {context?.gym?.name !== undefined && (
            <button
              onClick={addGymToUser}
              className='btn bg-info text-white f-13 mx-2'
            >
              افزودن
            </button>
          )}
        </div>
      </div>
    </ModalCustom>
  );
};

export default GymModal;
